import React, {Component} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import Login from '../components/Auth/Login';
import Signup from '../components/Auth/Signup';
import ProfileQuestion from "../components/Auth/ProfileQuestion";
import SignupSuccess from "../components/Auth/SignupSuccess";
import SetPassword from "../components/Auth/SetPassword";
import ForgotPassword from '../components/Auth/ForgotPassword';
import ResetPassword from '../components/Auth/ResetPassword';
import RegistrationSuccess from "../components/Auth/RegistrationSuccess";
import Unauthorized from '../components/Unauthorized';
import AuthMiddleware from '../components/AuthMiddleware';
import EditProfile from "../components/User/EditProfile";
import Splash from "../components/Home/Splash";
import Home from "../components/Home/Home";
import PlayFilm from "../components/Film/PlayFilm";
import About from "../components/Common/About";
import Dashboard from "../components/Dashboard/Dashboard";
import ChangePassword from "../components/User/ChangePassword";
import TagCloud from "../components/Dashboard/TagCloud";
import UserGuide from "../components/StaticPages/UserGuide";
import UserGuideVideo from "../components/StaticPages/UserGuideVideo";
import JoinUs from "../components/StaticPages/JoinUs";
import AfterVideo from "../components/StaticPages/AfterVideo";
import Story from "../components/Story/Story";
import Donate from "../components/Donate/Donate";
import DonateMobile from "../components/Donate/DonateMobile";
import Incentive from "../components/Incentive/Incentive";

export default class Router extends Component{

render(){
    return (
        <div>
            <BrowserRouter>
                <div>
                    <Switch>
                        <Route path="/incentive" component={Incentive} />
                        <Route path="/edit-profile" component={AuthMiddleware(EditProfile)}/>
                        <Route path="/forgot-password" component={AuthMiddleware(ForgotPassword, [true])} />
                        <Route path="/reset-password" component={AuthMiddleware(ResetPassword, [true])} />
                        <Route path='/unauthorized' component={Unauthorized} />
                        <Route path="/login" component={AuthMiddleware(Login, [true])} />
                        <Route path="/signup" component={AuthMiddleware(Signup, [true])} />
                        <Route path="/profile-questions" component={AuthMiddleware(ProfileQuestion, [true])} />
                        <Route path="/set-password" component={AuthMiddleware(SetPassword, [true])} />
                        <Route path="/signup-success" component={AuthMiddleware(SignupSuccess, [true])} />
                        <Route path="/registration-success" component={AuthMiddleware(RegistrationSuccess)} />
                        <Route path="/home" component={UserGuide} />
                        <Route path="/play-film" component={PlayFilm} />
                        <Route path="/join-us" component={JoinUs} />
                        <Route path="/about" component={About} />
                        <Route path="/dashboard" component={AuthMiddleware(Dashboard)} />
                        <Route path="/story-detail/:storyId" component={AuthMiddleware(Story)} />
                        <Route path="/donate" component={Donate} />
                        <Route path="/after-video" component={AfterVideo} />
                        <Route path="/change-password" component={AuthMiddleware(ChangePassword)} />
                        <Route path="/tag-cloud" component={TagCloud} />
                        <Route path="/user-guide" component={UserGuide} />
                        <Route path="/user-guide-video" component={UserGuideVideo} />
                        <Route path="/donate-mobile" component={DonateMobile} />
                        <Route path="/" component={UserGuide} />
                    </Switch>
                </div>
            </BrowserRouter>
        </div>
      );
    }
}



// WEBPACK FOOTER //
// ./config/router.js